export enum CHECKBOX_ALIGN {
  DEFAULT = 'default',
  VERTICAL = 'vertical'
}
